<template>
  <div>
    <div v-if="!this.notes.profile_notes" class="d-flex justify-content-center">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else class="notes">
      <div>
        <h2>
          Notatki użytkownika
          {{ this.userById.user_profile.profile.first_name }}
          {{ this.userById.user_profile.profile.last_name }}
        </h2>
      </div>

      <div class="notesList" v-if="notes">
        <button
          class="btn btn-outline-dark"
          style="margin-bottom: 10px"
          data-toggle="modal"
          data-target="#addNewNote"
          @click="setDataToAdd()"
        >
          Dodaj notatkę
        </button>

        <div v-for="task in notes.profile_notes" :key="task.id">
          <div class="task note-block" type="button">
            <div
              style="margin-right: 10px"
              data-toggle="collapse"
              :data-target="`#messages${task.id}`"
              aria-expanded="false"
              aria-controls="messages"
              class="titlePlace"
            >
              <p>
                Dodał: {{ task.admin_user.phone }}<br />
                {{ formattedDate(task.creationDate) }}
                <br />
                Kategoria: {{ task.category }}
              </p>
              <div class="taskTitle">
                {{ task.title }}
              </div>
            </div>
            <button
              class="addTaskIcon"
              data-toggle="modal"
              data-target="#addNewTask"
              @click="setAdminData(task)"
            >
              <i class="fas fa-plus text-white"></i>
            </button>

            <span class="userInfo" v-if="task.associated_user">
              {{ task.associated_profile.first_name }}
              {{ task.associated_profile.last_name }} -
              {{ task.associated_user.phone }}
              <br />
              <span v-if="task.contact_type === 'PHONE'">Telefon odebrany</span>
              <span v-if="task.contact_type === 'PHONE_OUT'"
                >Telefon wykonany</span
              >
              <span v-if="task.contact_type === 'EMAIL'"
                >Kontakt mailowy - {{ task.associated_profile.email }}</span
              >
              <span v-if="task.contact_type === 'CHAT'"
                >Kontakt poprzez czat</span
              >
              <span v-if="task.contact_type === 'LIST'"
                >Kontakt listowny
                <span v-if="task.associated_profile.postcode">
                  {{ task.associated_profile.postcode }}
                  {{ task.associated_profile.city }},
                  {{ task.associated_profile.street }}
                  {{ task.associated_profile.number1
                  }}{{
                    task.associated_profile.number2
                      ? `/${task.associated_profile.number2}`
                      : ""
                  }}</span
                ></span
              >
            </span>
          </div>

          <div class="collapse" :id="`messages${task.id}`">
            <div class="card card-body">
              <button
                class="btn btn-outline-dark btn-sm"
                style="margin-bottom: 10px"
                data-toggle="modal"
                data-target="#addNewTaskMessage"
                @click="setTaskForNewMessages(task.id)"
              >
                Dodaj nową wiadomość
              </button>
              <div v-for="message in task.messages" :key="message.id">
                <div class="messageContent">
                  <div>
                    <p>{{ formattedDate(message.creationDate) }}</p>
                    <p
                      v-if="
                        message.author_profile &&
                        message.author_profile.first_name !== null
                      "
                    >
                      <b
                        >{{ message.author_profile.first_name }} ({{
                          message.author.phone
                        }})</b
                      >
                    </p>
                  </div>
                  <div class="messageText">
                    {{ message.message }}
                  </div>
                  <div class="messageAttachment" v-if="message.file_path">
                    <span v-if="message.file_type === 'ATTACHMENT'">
                      <button
                        class="
                          taskMessageAttachment
                          btn btn-sm btn-outline-dark
                        "
                        @click="getFile(message.file_path, message.id)"
                      >
                        Załącznik do pobrania
                      </button>
                    </span>
                    <span v-if="message.file_type === 'IMAGE'">
                      <a target="_blank" :href="message.file_path">
                        <img :src="message.file_path" />
                      </a>
                    </span>
                  </div>

                  <i
                    @click="removeProfileNote(message.id)"
                    class="fas fa-times trashIcon"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- new profile note -->
      <div
        class="modal fade"
        id="addNewNote"
        tabindex="-1"
        role="dialog"
        aria-labelledby="c"
        data-backdrop="static"
      >
        <div ref="addModal" class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addNewNote">
                Dodawanie nowej notatki
              </h5>
              <button
                type="button"
                class="close"
                data-toggle="modal"
                :data-target="
                  areFieldsEmpty ? '#addNewNote' : '#closeAddNewNote'
                "
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form
                class="addNewTaskForm"
                @submit.prevent="addProfileNote()"
                ref="noteForm"
              >
                <div class="input-container">
                  <select v-model="taskCategory" class="form-control">
                    <option value="" selected disabled>Kategoria</option>
                    <option
                      :value="category"
                      v-for="category in this.taskCategories"
                      :key="category"
                    >
                      {{ category }}
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <input
                    v-model="title"
                    id="title"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="255"
                    placeholder="Tytuł"
                  />
                </div>
                <div class="input-container">
                  <textarea
                    v-model="message"
                    id="message"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="1024"
                    placeholder="Wiadomość..."
                  />
                </div>
                <select v-model="contactType" class="form-control">
                  <option value="" selected disabled>Sposób konktaktu</option>
                  <option
                    :value="contactType"
                    v-for="contactType in this.contactTypes"
                    :key="contactType"
                  >
                    <span v-if="contactType === 'PHONE'">Telefon odebrany</span>
                    <span v-if="contactType === 'PHONE_OUT'"
                      >Telefon wykonany</span
                    >
                    <span v-if="contactType === 'EMAIL'">Email</span>
                    <span v-if="contactType === 'CHAT'">Czat</span>
                    <span v-if="contactType === 'LIST'">List</span>
                  </option>
                </select>
                <label>
                  <input
                    type="file"
                    @change="getImage($event)"
                    id="file-input"
                  />
                </label>
                <button
                  class="buttonm btn btn-outline-dark"
                  type="submit"
                  ref="addNoteBtn"
                >
                  Zapisz
                </button>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark"
                ref="addNoteBtnClose"
                data-toggle="modal"
                :data-target="
                  areFieldsEmpty ? '#addNewNote' : '#closeAddNewNote'
                "
                id="addNoteBtnClose"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- close add note -->
      <div
        class="modal fade"
        style="padding: 0 0; transform: translate(0, -5%)"
        id="closeAddNewNote"
        data-backdrop="false"
        role="dialog"
        data-show="true"
      >
        <div class="modal-dialog modal-sm modal-dialog-centered p-0">
          <div class="modal-content">
            <div class="modal-header">
              <p>Czy chcesz zamknać notatkę bez zapisywania?</p>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-outline-dark"
                data-dismiss="modal"
                @click="handleCloseWithSave"
              >
                Zapisz
              </button>
              <button
                type="button"
                class="btn btn-outline-dark"
                @click="handleCloseWithoutSave"
                data-dismiss="modal"
              >
                Nie zapisuj
              </button>
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
                ref="closeBtn"
              >
                Anuluj
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- new task -->
      <div
        class="modal fade"
        id="addNewTask"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addNewTask"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Dodawanie nowego zadania</h5>
              <button
                type="button"
                class="close"
                data-toggle="modal"
                data-target="#closeAddNewTask"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="addNewTaskForm" @submit.prevent="addNewAdminTask()">
                <div class="input-container">
                  <select v-model="taskCategory" class="form-control">
                    <option value="" selected disabled>Kategoria</option>
                    <option
                      :value="category"
                      v-for="category in this.taskCategories"
                      :key="category"
                    >
                      {{ category }}
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <input
                    v-model="title"
                    id="title"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="255"
                    placeholder="Tytuł"
                  />
                </div>
                <div class="input-container">
                  <textarea
                    v-model="message"
                    id="message"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="1024"
                    placeholder="Wiadomość..."
                  />
                </div>

                <select v-model="contactType" class="form-control">
                  <option value="" selected disabled>Sposób konktaktu</option>
                  <option
                    :value="contactType"
                    v-for="contactType in this.contactTypes"
                    :key="contactType"
                  >
                    <span v-if="contactType === 'PHONE'">Telefon odebrany</span>
                    <span v-if="contactType === 'PHONE_OUT'"
                      >Telefon wykonany</span
                    >
                    <span v-if="contactType === 'EMAIL'">Email</span>
                    <span v-if="contactType === 'CHAT'">Czat</span>
                    <span v-if="contactType === 'LIST'">List</span>
                  </option>
                </select>
                <label>
                  <input
                    type="file"
                    @change="getImage($event)"
                    id="file-input"
                  />
                </label>
                <div class="datepickers">
                  <datepicker
                    :monday-first="true"
                    :language="pl"
                    v-model="date_to"
                    name="taskDateTo"
                    :placeholder="'Termin wykonania zadania'"
                  ></datepicker>
                </div>
                <div class="input-container">
                  <select v-model="taskPriority" class="form-control">
                    <option value="ONE" selected disabled>Priorytet</option>
                    <option
                      :value="priority"
                      v-for="priority in this.taskPriorities"
                      :key="priority"
                    >
                      {{ priority }}
                    </option>
                  </select>
                </div>
                <button class="buttonm btn btn-outline-dark" type="submit">
                  Zapisz
                </button>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark"
                data-toggle="modal"
                data-target="#closeAddNewTask"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- new task close modal -->

      <div
        class="modal fade"
        style="padding: 0 0; transform: translate(0, -5%)"
        id="closeAddNewTask"
        data-backdrop="false"
        data-show="true"
      >
        <div class="modal-dialog modal-sm modal-dialog-centered p-0">
          <div class="modal-content">
            <div class="modal-header">
              <p>Czy chcesz zamknać formularz bez zapisywania?</p>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-outline-dark"
                data-dismiss="modal"
                @click="handleCloseWithSaveTask"
              >
                Zapisz
              </button>
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
                @click="handleCloseWithoutSaveTask"
              >
                Nie zapisuj
              </button>
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
              >
                Anuluj
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="addNewTaskMessage"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addNewTaskMessage"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addNewTaskMessage">
                Dodawanie nowej wiadomości
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form
                class="addNewTaskForm"
                @submit.prevent="addNewTaskMessage()"
              >
                <div class="input-container">
                  <label>Wiadomość</label>
                  <textarea
                    v-model="newTaskMessage"
                    id="title"
                    class="form-control mb-4"
                    type="text"
                    minlength="1"
                    placeholder="Nowa wiadomość"
                  />

                  <input
                    type="file"
                    @change="getImage($event)"
                    id="message-file-input"
                  />
                </div>
                <button class="buttonm btn btn-outline-dark" type="submit">
                  Zapisz
                </button>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
import axios from "../axios";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";

export default {
  name: "Notes",
  components: { Datepicker },

  data() {
    return {
      pl: pl,
      is_important: false,
      date_to: "",
      title: "",
      userPhone: "",
      message: "",
      newTaskMessage: "",
      taskId: "",
      taskCategories: [],
      contactTypes: [],
      contactType: "",
      taskCategory: "",
      noteId: "",
      filteringOptions: [
        {
          name: "ALL",
          displayName: "Wszystkie",
        },
        {
          name: "DONE",
          displayName: "DONE",
        },
        {
          name: "TODO",
          displayName: "TODO",
        },
      ],
      secondFilteringOptions: [
        {
          name: "",
          displayName: "Wszystkie",
        },
        {
          name: "PROFILE",
          displayName: "Profil",
        },
        {
          name: "PAYMENT",
          displayName: "Płatność",
        },
        {
          name: "DEATH",
          displayName: "Śmierć",
        },
        {
          name: "STEALING",
          displayName: "Kradzień konta",
        },
        {
          name: "DELETED_ACCOUNT",
          displayName: "Usunięcie konta",
        },
        {
          name: "RODO",
          displayName: "Rodo",
        },
        {
          name: "VERIFICATION",
          displayName: "Weryfikacja",
        },
        {
          name: "SERVICE",
          displayName: "Usługa",
        },
      ],
      allShowed: true,
      file: null,
      admins: [],
      taskPriorities: [],
      taskPriority: "ONE",
      isLoading: false,
    };
  },

  created() {
    this.$store.dispatch("fetchAllAdmins");
    this.getUserData();
    this.formattedDate = shared.formattedDateAsNumbers;
    this.isToday = shared.isToday;
    this.isFuture = shared.isFuture;
    this.$store.dispatch("fetchNotes", {
      on_page: this.notes.on_page,
      page_number: this.notes.page_number,
      search_param: this.$route.query.id,
    });

    axios.get(`/api/profileNote/categories`).then((response) => {
      this.taskCategories = response.data;
    });

    axios.get(`/api/adminTask/priorities`).then((response) => {
      this.taskPriorities = response.data;
    });

    axios.get(`/api/profileNote/contactTypes`).then((response) => {
      this.contactTypes = response.data;
      [this.contactTypes[1], this.contactTypes[4]] = [
        this.contactTypes[4],
        this.contactTypes[1],
      ];
    });
  },

  methods: {
    handleCloseWithSave() {
      if (
        this.title === "" ||
        this.message === "" ||
        this.contactType === "" ||
        this.taskCategory === ""
      ) {
        return this.$notify({
          group: "error",
          text: "Wypełnij notatkę aby można było ją zapisać.",
        });
      } else {
        this.addProfileNote();
        document.querySelector('[data-target="#addNewNote"]').click();
      }
    },
    async handleCloseWithSaveTask() {
      if (
        this.title === "" ||
        this.message === "" ||
        this.contactType === "" ||
        this.taskCategory === ""
      ) {
        return this.$notify({
          group: "error",
          text: "Wypełnij formularz aby dodać nowe zadanie.",
        });
      } else {
        const result = await this.addNewAdminTask();
        if (result === true) {
          document.querySelector('[data-target="#addNewTask"]').click();
        }
      }
    },

    handleCloseWithoutSave() {
      document.querySelector('[data-target="#addNewNote"]').click();
    },
    handleCloseWithoutSaveTask() {
      document.querySelector('[data-target="#addNewTask"]').click();
    },

    async getFile(id, messageId) {
      axios({
        url: id,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", messageId + "." + id.split(".").pop());
        document.body.appendChild(link);
        link.click();
      });
    },
    getImage(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    setAdminData(task) {
      this.title = "";
      this.message = "";
      this.taskCategory = "";
      this.userPhone = "";
      this.contactType = "";

      this.taskCategory = task.category;
      this.title = task.title;
      this.contactType = task.contact_type;
      this.userPhone = task.associated_user.phone;
      this.noteId = task.id;
      this.message = task.messages[0].message;
    },
    fetchNotes() {
      this.$store.dispatch("fetchNotes", {
        on_page: this.notes.on_page,
        page_number: this.notes.page_number,
        search_param: this.$route.query.id,
        filter_param: this.filterParam,
        own: !this.allShowed,
        second_filter_param: this.secondFilterParam,
      });
    },
    showOwn() {
      this.allShowed = false;
      this.fetchNotes();
    },
    showAll() {
      this.allShowed = true;
      this.fetchNotes();
    },
    setDataToAdd() {
      this.userPhone = this.$route.query.search;
    },
    setTaskForNewMessages(id) {
      this.taskId = id;
    },

    addNewTaskMessage() {
      if (!this.newTaskMessage && !this.file) {
        return this.$notify({
          group: "error",
          text: "Wiadomośc nie może być pusta. Musi zawierać teks lub załącznik",
        });
      }
      const url = `/api/profileNoteMessage/${this.taskId}`;

      const body = new FormData();
      body.append("message", this.newTaskMessage);
      body.append("file", this.file);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(url, body, config)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano wiadomość",
            });
            this.fetchNotes();
            this.newTaskMessage = "";
            this.file = null;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się dodać wiadomości",
          });
        });
    },

    //ADD NEW PROFILE NOTE
    addProfileNote() {
      const url = `/api/profileNote`;
      if (!this.taskCategory) {
        this.$notify({
          group: "error",
          text: "Wybierz kategorię",
        });
        return;
      }

      const body = new FormData();
      body.append("message", this.message);
      body.append("title", this.title);
      body.append("category", this.taskCategory);
      body.append("file", this.file);
      body.append("associated_user", this.$route.params.id);
      body.append("contact_type", this.contactType);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(url, body, config)

        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano zadanie",
            });
            (this.title = ""),
              (this.message = ""),
              (this.taskCategory = ""),
              (this.userPhone = ""),
              (this.contactType = "");
            this.category = "";
            this.file = null;
            (this.associated_user = null), (this.title = "");
            this.fetchNotes();
            setTimeout(() => {
              const btnToClose = document.getElementById("addNoteBtnClose");
              if (btnToClose) {
                btnToClose.click();
              }
            }, 500);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
          if (
            err.response.data.message ===
            "Not found user with this phone number"
          ) {
            this.$notify({
              group: "error",
              text: "Nie istnieje użytkownik o takim numerze",
            });
          }
        });
    },

    //ADD NEW TASK
    async addNewAdminTask() {
      const url = `/api/adminTask`;
      if (!this.taskCategory) {
        this.$notify({
          group: "error",
          text: "Wybierz kategorię",
        });
        return false;
      }

      const isCorrectDate =
        this.isToday(this.date_to) || this.isFuture(this.date_to);
      if (!isCorrectDate) {
        this.$notify({
          group: "error",
          text: "Podano niepoprawny termin wykonania zadania",
        });
        return false;
      }

      const body = new FormData();
      body.append("message", this.message);
      body.append("title", this.title);
      body.append("category", this.taskCategory);
      body.append("file", this.file);
      //body.append("associated_user", this.userPhone);
      body.append("contact_type", this.contactType);
      body.append("is_important", this.is_important);
      body.append("date_to", this.date_to);
      body.append("user_id", this.$route.params.id);
      body.append("profile_note_id", this.noteId);
      body.append("priority", this.taskPriority);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };

      axios
        .put(url, body, config)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano zadanie",
            });
            this.fetchNotes()((this.title = "")),
              (this.message = ""),
              (this.taskCategory = ""),
              (this.userPhone = ""),
              (this.contactType = "");
            this.category = "";
            this.file = null;
          }
        })
        .catch((err) => {
          console.log(err.response.data);
          if (
            err.response.data.message ===
            "Not found user with this phone number"
          ) {
            this.$notify({
              group: "error",
              text: "Nie istnieje użytkownik o takim numerze",
            });
          }
        });
      return true;
    },

    async removeProfileNote(noteId) {
      if (!this.isLoading) {
        this.isLoading = true;
        const url = `/api/profileNoteMessage/${noteId}`;
        await axios
          .delete(url)
          .then(() => {
            this.fetchNotes();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 1000);
          });
      }
    },
    getUserData() {
      this.$store.dispatch("getUserById", {
        userId: this.$route.params.id,
      });
    },
  },

  computed: {
    userById() {
      return this.$store.getters.getUserById;
    },
    allAdmins() {
      return this.$store.getters.getAllAdmins;
    },
    // OLD
    notes() {
      return this.$store.getters.getProfileNotes;
    },
    searchParams() {
      return this.$store.getters.getSearchParameter;
    },
    filterParam() {
      return this.$store.getters.getFilterParameter;
    },
    secondFilterParam() {
      return this.$store.getters.getSecondFilterParameter;
    },

    areFieldsEmpty() {
      return (
        this.title === "" &&
        this.message === "" &&
        this.contactType === "" &&
        this.taskCategory === "" &&
        this.file === null
      );
    },
  },
};
</script>

<style scoped>
.notes {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.notesList {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.task {
  position: relative;
  cursor: initial;
  width: 70vw;
  text-align: left;
}
.addTaskIcon {
  position: absolute;
  top: 5px;
  font-size: 20px;
  right: 10px;
  cursor: pointer;
  background: transparent;
  border: none;
}
.copyIcon {
  position: absolute;
  top: 27%;
  font-size: 20px;
  right: 3px;
  cursor: pointer;
}
.trashIcon {
  position: absolute;
  top: 5px;
  font-size: 15px;
  right: 5px;
  cursor: pointer;
  color: rgb(255, 0, 0);
}
.menagment-panel {
  justify-content: space-around;
}
.collapse,
.card {
  width: 69vw;
}
.messageContent {
  position: relative;
  border: 1px solid rgb(219, 208, 208);
  border-radius: 4px;
}
.addNewTaskForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.addNewTaskForm input,
.addNewTaskForm textarea,
.addNewTaskForm button,
.addNewTaskForm select {
  width: 400px;
}
.addNewTaskForm textarea {
  height: 100px;
}

.addNewTaskForm button {
  margin-top: 20px;
}
.userInfo {
  position: absolute;
  bottom: 0;
  right: 3px;
}
.titlePlace {
  text-align: center;
}
.taskTitle {
  width: 600px;
  font-size: 14px;
  margin: 0 auto;
}
.taskMessageAttachment {
  border-radius: 50px;
}

.note-block {
  background: linear-gradient(
    36.47deg,
    rgb(251, 137, 40) 10.51%,
    #e50582 109.44%
  ) !important;
  color: white;
  font-weight: 600;
  border-radius: 5px;
}

@media screen and (max-width: 1600px) {
  .userInfo {
    position: relative;
  }
}
</style>
